module.exports = __webpack_public_path__ + "img/pothole.75ef09d6.jpg";